// src/js/reducers/index.js
import * as types from "../constants/action-types";

export default function jobTypeReducer(state = [], action) {
    switch (action.type) {
      
        case types.LOGOUT:
            return []
        case types.CREATE_JOB_TYPE_SUCCESS:
        
            var result = [...state, Object.assign({}, action.jobType)];
          
            return result;

        case types.UPDATE_JOB_TYPE_SUCCESS:
        
            var result = [...state.filter(jobType => jobType.jobTypeId !== action.jobType.jobTypeId), 
                Object.assign({}, action.jobType)];
           
            return result;

        case types.LOAD_JOB_TYPE_SUCCESS:
        
            
            return action.jobTypes;

      

        default:
            return state;
    };
};
